import TruncateText from '@creditflowresearch/uilib/TruncateText';

interface ITruncatedTextCellProps {
  value: string | null | undefined,
  tooltip?: string,
}

const TruncatedTextCell = ({ value, tooltip }: ITruncatedTextCellProps) => {
  if (!value) {
    return (<>-</>);
  }

  return (
    <TruncateText value={ tooltip || value }>{ value }</TruncateText>
  );
};

export default TruncatedTextCell;
